<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a start and end date:</div>
        <div class="row expanded">
          <div class="small-6 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-6 column padding-L">
            <div class="date-input end-date">
              <label>End Date:</label>
              <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="download-type">
            <label :class="{'pdf':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="pdfChecked"
                @click="formatCheck" />
              PDF
            </label>
            <label :class="{'csv':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="csvChecked"
                @click="formatCheck" />
              CSV
            </label>
          </div>
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.completedRsvp, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.completedRsvp" />
                <span>{{ reportLabel('completedRsvp') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.completedRsvp}"
                :disabled="!selectedReports.completedRsvp" v-model="completeRsvpAirport">
                <option value="0">Please select airport</option>
                <option v-for="airport in airports" :value="airport.geofenceId">
                  {{ airport.airportCode }} - {{ airport.description }}
                </option>
              </select>
              <div :class="['brand-select', {disabled:!selectedReports.completedRsvp}]">
                <label v-for="brand in brands.list" :key="brand.id">
                  <input type="checkbox" name="brand" v-model="completeRsvpBrands" :value="brand.id" />
                  {{ brand.name }}
                </label>
              </div>
            </div>
            <div :class="['small-12 column report', reportStatus.eventLogs, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.eventLogs" />
                <span>{{ reportLabel('eventLogs') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.eventLogs || geoTracking.loading}"
                :disabled="!selectedReports.eventLogs || geoTracking.loading" v-model="eventLogsAirport">
                <option value="0">Please select service area</option>
                <option v-for="servicearea in geoTracking.list" :value="servicearea.id">
                  {{ servicearea.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="empty in error.empty">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: pdf.loading }"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="pdf.loading"></i>
          <span v-show="!pdf.loading">Generate and Download Report</span>
        </a>
      </div>

      <div id="pdf-view" :class="[pdf.class]">
        <div v-for="(pageData, pageIndex) in pdf.table.data" :class="['page', pageIndex]" :key="pageIndex">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pageData" :key="index">
                <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
              </tr>
              <tr v-if="isPayout && currentPage(pageIndex) == totalPage" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="driverCount">{{ pdf.table.total.drivers }}</td>
                <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
                <!-- <td class="totalPax">{{ pdf.table.total.pax }}</td>
                <td class="avgPax">{{ pdf.table.total.avgPax }}</td> -->
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td class="travelInsurance">${{ pdf.table.total.travelInsurance }}</td>
                <td class="airportFee">${{ pdf.table.total.airportFee }}</td>
                <td class="totalFare">${{ pdf.table.total.fareSum }}</td>
                <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
                <td class="payment">${{ pdf.table.total.payment }}</td>
                <td class="paymentPercent">{{ pdf.table.total.paymentPercent }}%</td>
                <td class="pickupFee">${{ pdf.table.total.pickupFee }}</td>
                <td class="gasFee">${{ pdf.table.total.gasFee }}</td>
                <td class="tips">${{ pdf.table.total.tips }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="cancelFee">${{ pdf.table.total.cancelFee }}</td>
                <td class="driverPayment">${{ pdf.table.total.extraFee }}</td>
                <td class="driverPercent">{{ pdf.table.total.percent }}%</td>
              </tr>
            </tbody>
          </table>
          <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
        </div>

        <div :class="['page', `page${Object.keys(pdf.table.data).length + 1}`]" v-if="Object.keys(pdf.table.data).length">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pdf.table.data[`page${Object.keys(pdf.table.data).length}`]" :key="index">
                <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
              </tr>
              <tr v-if="isPayout" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="driverCount">{{ pdf.table.total.drivers }}</td>
                <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td class="travelInsurance">${{ pdf.table.total.travelInsurance }}</td>
                <td class="airportFee">${{ pdf.table.total.airportFee }}</td>
                <td class="totalFare">${{ pdf.table.total.fareSum }}</td>
                <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
                <td class="payment">${{ pdf.table.total.payment }}</td>
                <td class="paymentPercent">{{ pdf.table.total.paymentPercent }}%</td>
                <td class="pickupFee">${{ pdf.table.total.pickupFee }}</td>
                <td class="gasFee">${{ pdf.table.total.gasFee }}</td>
                <td class="tips">${{ pdf.table.total.tips }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="cancelFee">${{ pdf.table.total.cancelFee }}</td>
                <td class="driverPayment">${{ pdf.table.total.extraFee }}</td>
                <td class="driverPercent">{{ pdf.table.total.percent }}%</td>
              </tr>
            </tbody>
          </table>
          <div class="page-count">page {{ Object.keys(pdf.table.data).length }} of {{ totalPage }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
// import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'specialize-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        completedRsvp: false,
        eventLogs: false
      },
      reportStatus: {
        completedRsvp: '',
        eventLogs: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['eventLogs', 'completedRsvp'],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      completeRsvpAirport: 0,
      completeRsvpBrands: [2, 4, 5],
      eventLogsAirport: 0,
      geoTracking: {
        list: [],
        loading: false
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = { to: null, from: null }
      if (self.from !== null) { result.from = self.from }
      if (self.to !== null) { result.to = self.to }
      return result
    },
    totalPage () { return Object.keys(this.pdf.table.data).length },
    airports () { return this.$store.state.airports.list },
    brands () { return this.$store.state.brands },
    isPayout () { return this.pdf.code === 'payout' && this.totalPage }
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let from = moment(self.from)
      let to = moment(self.to)

      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }
      self.formatError = false
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true
        self.error.message = 'Please select which file format.'
        self.formatError = true
        return false
      }
      if (!self.selectedReports.completedRsvp && !self.selectedReports.eventLogs) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }

      if (self.selectedReports.completedRsvp && self.completeRsvpAirport === 0) {
        self.error.show = true
        self.error.message = 'Please select an airport.'
        return false
      }
      if (self.selectedReports.completedRsvp && !self.completeRsvpBrands.length) {
        self.error.show = true
        self.error.message = 'Please select atleast 1 brand.'
        return false
      }

      if (self.selectedReports.eventLogs && self.eventLogsAirport === 0) {
        self.error.show = true
        self.error.message = 'Please select a service area.'
        return false
      }

      return true;
    },
    getNewDoc () {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.setFont('helvetica')
      return doc
    },
    startProcess () {
      if (!this.isValid()) { return }
      this.pdf.list = []
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.pdf.list.push(report)
          this.csv.list.push(report)
        }
      }
      this.pdf.loading = true
      this.generateReport()
    },
    generateReport (isCsv = false) {
      if (((!this.pdf.list.length && this.pdfChecked) || !this.pdfChecked) &&
        ((!this.csv.list.length && this.csvChecked) || !this.csvChecked)
      ) {
        this.pdf.loading = false
        return
      }
      if (isCsv) {
        console.log('Processing:', this.csv.list[0])
        this.getDataReports(this.csv.list[0])
      } else {
        console.log('Processing:', this.pdf.list[0])
        this.getDataReports(this.pdf.list[0])
      }
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      let orientationMax = self.orientation
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }
        self.setPdfLabel(type)
        self.pdf.table.data = {}
        self.pdf.table.extra = {}
        self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}
        if (r.list.length > 0) {
          self.buildPdfData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      let url = ''
      let start = moment(this.from)
      let end = moment(this.to)
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }
      switch (type) {
        case 'completedRsvp':
          url = '/reports/tnc/rsvp'
          data.geofenceId = this.completeRsvpAirport
          data.brandIds = this.completeRsvpBrands
          break
        case 'eventLogs':
          url = '/reports/tnc/log'
          data.geofenceId = this.eventLogsAirport
          break
      }
      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = moment(this.from)
      let end = moment(this.to)
      let dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY')
      this.pdf.code = type
      if (type === 'completedRsvp') {
        this.pdf.class = 'report-completed'
        let i = this.airports.findIndex(x => x.geofenceId === this.completeRsvpAirport)
        this.pdf.title = `Opoli Reports - Completed Reservations (${this.airports[i].airportCode} Airport)`
        this.pdf.date = dateRange
        this.pdf.table.label = [
          'Brand', 'RSVP ID', 'Completed Date', 'Distance (miles)',
          'ETA (sec)', 'Driver', 'Pickup Geofence',
          'Dropoff Geofence'
        ]
      }
      if (type === 'eventLogs') {
        this.pdf.class = 'report-completed'
        this.pdf.title = 'Opoli Reports - Real time Event Logs'
        this.pdf.date = dateRange
        this.pdf.table.label = [
          'RSVP ID', 'Geofence', 'UID', 'Driver ID',
          'License Plate', 'TNC ID', 'Date',
          'Type', 'Ride Count'
        ]
      }
    },
    buildPdfData (type, pdfData) {
      let self = this
      // let groupCount = 0
      let page = 1
      // payout
      // let totalDrivers = 0
      // let totalRsvp = 0
      // let totalPickupFee = 0
      // let totalTips = 0
      // let totalBonus = 0
      // let totalCancelFee = 0
      // let totalGasFee = 0
      // let totalFare = 0
      // let totalFareSum = 0
      // let totalAvgFare = 0
      // let totalTravelInsurance = 0
      // let totalAirportFee = 0
      // let totalPayment = 0
      // let totalBidAmount = 0
      // let totalPaymentPercentage = 0
      // let totalAvgFarePP = 0
      // let totalDriverPaymentOld = 0
      // let totalDriverPayment = 0
      // let totalDriverPercentage = 0
      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }
        self.pdf.table.data['page' + page].push(self.buildTableData(type, data))
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data))
        }
        // groupCount++
        if (type === 'completedRsvp') {
          // totalDrivers += data.drivers
          // totalRsvp += data.rsvp
          // totalGasFee += data.gasFee
          // totalFare += data.bidAmount
          // totalTravelInsurance += parseFloat(data.travelInsurance || 0)
          // totalAirportFee += parseFloat(data.airportFee || 0)
          // totalFareSum += data.fareSum
          // totalAvgFare += parseFloat(data.fareAvg)
          // totalDriverPaymentOld += parseFloat((data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee)
          // totalDriverPayment += data.payoutStatus ? parseFloat(data.finalPayout) : data.total
          // totalDriverPayment += data.gasFee
          // totalPayment += data.payment
          // totalBidAmount += data.bidAmount
          // totalPickupFee += data.pickupFee
          // totalTips += data.tips
          // totalBonus += data.bonus
          // totalCancelFee += data.cancelFee
          // totalPaymentPercentage += parseFloat(data.paymentPercent || 0)
          // totalDriverPercentage += parseFloat(data.percent)
        }
        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) { page++ }
      })
      self.pdf.table.total.record = pdfData.length
      if (type === 'completedRsvp') {
        // self.pdf.table.total.drivers = self.covertNumber(totalDrivers)
        // self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        // self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2))
        // self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2))
        // self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2))
        // self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2))
        // self.pdf.table.total.gasFee = self.covertNumber(totalGasFee.toFixed(2))
        // self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        // self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2))
        // self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2))
        // self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2))
        // self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2))
        // self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2))
        // let paymentPercent = (totalPayment / totalFareSum) * 100
        // self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2))
        // let averagePercentage = totalDriverPercentage / pdfData.length
        // self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2))
        // self.pdf.table.total.percent = self.covertNumber(((totalDriverPaymentOld / totalFareSum) * 100).toFixed(2))
      }
      if (self.pdfChecked) {
        self.processDownloads('pdf', {type: type, page: page})
      } else {
        self.processDownloads('csv', {type: type})
      }
    },
    buildTableData (type, data) {
      // let self = this
      if (type === 'completedRsvp') {
        return {
          brand: data.brand.name,
          id: data.rsvpId,
          complete: moment(data.complete, 'YYYY-MM-DD@hh:mm').format('MM/DD/YYYY hh:mmA'),
          distance: data.distance,
          eta: data.etaInSec,
          driver: data.driver.name,
          pickupGeofence: data.pickupGeofence.name,
          dropoffGeofence: data.dropoffGeofence.name
        }
      }
      if (type === 'eventLogs') {
        return {
          rsvpId: data.rsvpId || '--',
          geofence: data.geofence_id,
          uid: data.uid,
          driverId: data.driverId,
          licensePlate: data.license_plate,
          tncId: data.tnc_id,
          date: moment.utc(data.timestamp, 'YYYY-MM-DD@hh:mm').tz('America/Los_Angeles').format('MM/DD/YYYY hh:mmA'),
          type: data.txn_type,
          rideCount: data.ride_count
        }
      }
    },
    fileName (type, format) {
      let timestamp = moment(this.from).format('YYYYMMDD') + '_' + moment(this.to).format('YYYYMMDD')
      switch (type) {
        case 'completedRsvp': return 'reports-Completed-RSVP_' + timestamp + '.' + format
        case 'eventLogs': return 'reports-Event-Logs_' + timestamp + '.' + format
      }
    },
    currentPage (page) { return page.substring(4) },
    processPdf (type, page) {
      let self = this
      let start = moment(self.from)
      let end = moment(self.to)
      let pageAsyncs  = []
      let landscapeReports = self.orientation
      let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      setTimeout(() => {
        if (self.isIOS) page = page + 1
        for (let i = 0; i < page; i++) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 1.0)
            pdf.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 !== page) { pdf.addPage() }
          }).catch(e => {
            self.reportStatus[type] = 'has-error'
            self.pdf.list.shift()
            document.body.style.overflow = 'auto'
            self.processDownloads('csv', {type: type})
            console.warn(e)
          }))
        }
        Promise.all(pageAsyncs).then(() => {
          let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
          pdf.save(self.fileName(type, 'pdf'))
          self.reportStatus[type] = 'success'
          self.pdf.list.shift()
          document.body.style.overflow = 'auto'
          self.processDownloads('csv', {type: type})
        })
      }, 500)
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    resetSelectedStatus () {
      this.selectedReports = {
        completedRsvp: false,
        eventLogs: false
      }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = {
        completedRsvp: '',
        eventLogs: ''
      }
    },
    reportLabel (type) {
      switch (type) {
        case 'completedRsvp': return 'Completed Reservations'
        case 'eventLogs': return 'Real-time Event Logs'
      }
    },
    buildCsvData (type, data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column
      let csvData = {}
      let pdfData = this.buildTableData(type, data)
      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })
      // add total
      this.csv.data.push(this.buildCsvTotal(type))
      exporter.downloadCsv(this.csv.data)
      this.reportStatus[type] = 'success'
      this.csv.list.shift()
      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let csvData = {}
      // let totalData = this.pdf.table.total
      if (type === 'completedRsvp') {
        // csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        // csvData[this.csv.label[1]] = totalData.drivers
        // csvData[this.csv.label[2]] = totalData.rsvp
        // csvData[this.csv.label[3]] = totalData.fare
        // csvData[this.csv.label[4]] = totalData.travelInsurance
        // csvData[this.csv.label[5]] = totalData.airportFee
        // csvData[this.csv.label[6]] = totalData.fareSum
        // csvData[this.csv.label[7]] = totalData.avgFare
        // csvData[this.csv.label[8]] = totalData.payment
        // csvData[this.csv.label[9]] = totalData.paymentPercent
        // csvData[this.csv.label[10]] = totalData.pickupFee
        // csvData[this.csv.label[11]] = totalData.gasFee
        // csvData[this.csv.label[12]] = totalData.tips
        // csvData[this.csv.label[13]] = totalData.bonus
        // csvData[this.csv.label[14]] = totalData.cancelFee
        // csvData[this.csv.label[15]] = totalData.extraFee
        // csvData[this.csv.label[16]] = totalData.percent
      }
      if (type === 'eventLogs') {
        // csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        // csvData[this.csv.label[1]] = ''
        // csvData[this.csv.label[2]] = ''
        // csvData[this.csv.label[3]] = ''
        // csvData[this.csv.label[4]] = totalData.fare
        // csvData[this.csv.label[5]] = ''
        // csvData[this.csv.label[6]] = ''
        // csvData[this.csv.label[7]] = ''
        // csvData[this.csv.label[8]] = ''
      }
      return csvData
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
    getGeoTrackingList () {
      let self = this
      self.geoTracking.loading = true
      self.$sdk.get('/geofences/tracking', {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: 'servicearea',
        orderAsc: 1,
        order: 'priority'
      }, r => {
        self.geoTracking.loading = false
        if (!r.error) {
          self.geoTracking.list = []
          r.list.forEach(g => {
            self.geoTracking.list.push({
              id: g.id,
              name: g.name
            })
          })
        }
      })
    }
  },
  watch: {
    show (value) {
      if (!value) { return }
      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []
      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.completedRsvp' () { this.resetReportStatus() },
    'selectedReports.eventLogs' () { this.resetReportStatus() },
  },
  mounted () {
    this.getGeoTrackingList()
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;
  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }
  & .date-input {
    margin-bottom: 10px;
    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;
      &[disabled]{ background-color: #ebebe4; }
    }
  }
  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;
    .report{
      position: relative;
      z-index: 1;
      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;
        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}
.filter{
  list-style: none;
  margin: 0 0 5px;
  padding: 0;
  font-size: 13px;
  display: flex;
  li{
    margin: 2px 0;
    width: 100%;
  }
  label{ cursor: pointer;}
  input{
    display: inline-block;
    margin: 0 3px 0 0;
    width: auto;
    vertical-align: middle;
  }
}
.download-type{
  float: right;
  width: 150px;
  text-align: right;
  padding-bottom: 5px;
  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 7px;
    border:1px solid #ddd;
    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}
.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}
.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;
  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;
    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}
.form-group {
  display: block;
  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}
.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
#pdf-view{
  position: absolute;
  top: 100%;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;
  .page{
    padding: 30px 40px 30px 30px;
    position: relative;
    width: 100%;
    height: 100%;
    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }
  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;
    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 12px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}
.report-completed{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody{
      td{
        text-align: center;
      }
      tr.total{
        border-top: 1px solid #333;
        font-weight: 600;
        font-size:12.5px;
      }
    }
  }
}

.brand-select{
  margin: 0 0 10px 28px;
  border: 1px solid #999;
  width: calc(100% - 43px);
  height: 120px;
  overflow: auto;

  &.disabled{
    opacity: .5;
  }
  label{
    border-bottom: 1px solid #ddd;
    padding: 4px 10px;
    font-size: 14px;
    background: #fff;
    display: block;
    cursor: pointer;
  }
  input{
    width: auto;
    display: inline-block;
    margin: 0 5px 5px 0;
    vertical-align: -1px;
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/LGBReport.vue